import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { ProgressBar, Spacer, rem } from 'design-system';
import Text from 'design-system/Text';
import { selectOnboardingTradingAccountForOnboardingFunnel } from 'features/invest/reducers/selectors';
import { getHasAccountsHeldElsewhere } from 'features/invest/utils';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { assertUnreachable } from 'utils';
import { NavigationHeaderWithAvatarAndHelp } from '../NavigationHeaderWithAvatar';
const Header = ({ status, contentContainerStyle }) => {
    const colors = useColors();
    const account = useAppSelector(selectOnboardingTradingAccountForOnboardingFunnel);
    const hasFunded = account?.hasFunded;
    const hasPostOpenInstructions = account?.hasPostOpenInstructions;
    const steps = useMemo(() => {
        switch (status) {
            case 'OPENING_IN_PROGRESS':
            case 'IDENTITY_CHECKS_IN_PROGRESS':
            case 'IDENTITY_CHECKS_NEED_USER_ACTION': {
                return {
                    step: 1,
                    progress: 25,
                };
            }
            case 'ACTIVE': {
                if (hasFunded) {
                    return {
                        step: 3,
                        progress: 75,
                    };
                }
                return {
                    step: 2,
                    progress: 50,
                };
            }
            default: {
                assertUnreachable(status);
                return {
                    step: 4,
                    progress: 75,
                };
            }
        }
    }, [hasFunded, status]);
    const positionInfo = useMemo(() => {
        if (hasPostOpenInstructions) {
            if (getHasAccountsHeldElsewhere(account?.account)) {
                return {
                    position: status === 'ACTIVE' ? 75 : 50,
                    text: status === 'ACTIVE' ? '4/4' : '3/4',
                };
            }
            return {
                position: 66.6,
                text: '3/3',
            };
        }
        return {
            position: steps.progress,
            text: `${steps.step}/4`,
        };
    }, [account, hasPostOpenInstructions, status, steps.progress, steps.step]);
    return (<>
      <NavigationHeaderWithAvatarAndHelp showTitle/>
      <View style={[styles.header, contentContainerStyle]}>
        <Text Text-16 Secondary>
          Good job!
        </Text>
        <Spacer h={8}/>
        <Text Text-24>You’re almost there!</Text>
        <Spacer h={16}/>
        <View style={styles.progressContainer}>
          <View style={styles.progressView}>
            <ProgressBar position={positionInfo.position} barBackgroundColor={colors.background.brandLight} colors={[colors.elements.brand, colors.elements.brand]}/>
          </View>
          <Spacer w={16}/>
          <View style={styles.stepsContainer}>
            <Text Text-14 OnBrand>
              {positionInfo.text}
            </Text>
          </View>
        </View>
      </View>
    </>);
};
export default Header;
const styles = StyleSheet.create({
    header: {
        paddingBottom: rem(16),
        paddingHorizontal: rem(16),
    },
    progressContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    stepsContainer: {
        width: 28,
        alignItems: 'flex-end',
    },
    progressView: {
        flex: 1,
        justifyContent: 'center',
    },
});
